import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";

import "../css/style.css"

const Confirmation = () => {
    const { orderId } = useParams();
    const { invoiceNumber } = useParams();

    const [tokenLoaded, setTokenLoaded] = useState(false);
    const [order, setOrder] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);
    const [loading, setLoading] = useState(true);

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching resources
    const { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        // gtm - purchase
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'purchase'
        });
    }, [])

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    useEffect(() => {
        requestResources();

    }, [language, tokenLoaded]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            setTokenLoaded(true);
            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            loadOrder(orderId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const order = await getOrderByOrderId(orderId);

            setOrder(order);

            let isValid = false;

            if (order == null) navigate(`/${language}/notfound`);

            // the url param is always a string, the invoice number from the api is numeric
            if (String(order.invoiceNumber) === String(invoiceNumber).trim()) {
                setLoading(false);
            } else {
                navigate(`/${language}/notfound`);
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getReceiptOfOrder = async () => {
        await axios
            .get(`${baseUrl}/Order/${orderId}/Receipt?organizerId=${organizerId}`, {
                responseType: "blob",
            })
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Receipt.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    const getPdfTicketsOfOrder = async () => {
        await axios
            .get(
                `${baseUrl}/Order/${orderId}/TicketsPdf?organizerId=${organizerId}`,
                {
                    responseType: "blob",
                }
            )
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Tickets.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    return (
        <div>
            {!loading &&
                <div className="container wrapper-ticket-download ps-0 pe-0">
                    <div className="mt-3 mb-3">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="title">
                                    <span>Dein Ticket zur CONNECT 2026</span>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12">
                                <p>
                                    Wir freuen uns, dich an der CONNECT 2026 begrüssen zu dürfen. Über den Button unten
                                    kannst du dein Ticket jederzeit erneut herunterladen. Halte es am Veranstaltungstag
                                    digital oder ausgedruckt bereit, damit dein Check-in schnell und unkompliziert verläuft.
                                </p>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12">
                                <p>
                                    Bitte beachte, dass während der CONNECT Fotos und Videos erstellt werden, die wir für
                                    unsere Kommunikations- und Marketingmassnahmen verwenden. Mit deiner Anmeldung erklärst
                                    du dich damit einverstanden, dass diese Aufnahmen veröffentlicht werden dürfen.
                                </p>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12">
                                <button
                                    className="custom-button ticket-download-button"
                                    onClick={() => getPdfTicketsOfOrder()}
                                >
                                    Lade hier dein Ticket runter
                                </button>
                            </div>
                        </div>
                    </div>

                    <p className="mt-5 text-center">
                        <small style={{ color: 'grey', fontSize: '11px' }}>powered by <a style={{ color: 'grey' }} href={resources?._TicketinoOrganizerUrl} target="_blank">TICKETINO</a></small>
                    </p>
                </div>
            }
        </div>
    )
}

export default Confirmation